/* eslint-disable */
/*!
* @houlagins/locale 1.0.0
* 
* Locale resolving service 
*
* @link https://github.com/randyhoulahan/locale/tree/master#readme
* @source git+https://github.com/randyhoulahan/locale.git
* @copyright (c) 2020 Randy Houlahan
* @license MIT
* 
*/

const unLocales = [ 'ar', 'en', 'es', 'fr', 'ru', 'zh' ];

const unLocalesSet = new Set(unLocales);

const html5Locale = () => {
  if(typeof window === 'undefined') return ''

  const htmlEl = document.querySelector('html');

  if(!htmlEl) return ''

  return htmlEl.getAttribute('lang') || ''
};

const legacyHtmlLocale = () => {
  if(typeof window === 'undefined' || typeof document === 'undefined') return ''

  const metaEl = document.querySelector('meta[http-equiv=content-language]');
  
  if(!metaEl) return ''
  return metaEl.getAttribute('content') || ''
};

const legacyBrowserLocale = () => {
  if(typeof navigator === 'undefined') return ''
  return (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || ''
};

const browserLocale = () => {
  if(typeof Intl === 'undefined') return ''
  return (new Intl.NumberFormat())? (new Intl.NumberFormat()).resolvedOptions().locale : ''
};

const get = () => {
  const locale =  html5Locale()|| legacyHtmlLocale() || legacyBrowserLocale() || browserLocale();

  return locale? locale.toLowerCase().slice(0, 2) : 'en'
};

const getUN = () => {
  const locale = get();

  for (const lang of unLocales)
    if(locale.includes(lang))
      return lang

  return 'en'
};

const getLocale = get;
const getUnLocale = getUN;

export { browserLocale, get, getLocale, getUN, getUnLocale, html5Locale, legacyBrowserLocale, legacyHtmlLocale, unLocalesSet };
//# sourceMappingURL=index.js.map
